export const validateColumnTypes = async (table) => {
  const headers = table[0];

  for (let row = 1; row < table.length; row++) {
    for (let col = 0; col < table[row].length; col++) {
      const value = table[row][col];

      if (value === '' || value === null || value === undefined) {
        continue;
      }

      const num = Number(value);
      if (isNaN(num)) {
        return {
          row: row + 1,
          column: headers[col],
          value: value,
        };
      }
    }
  }

  return null;
};
